import GoMenuDrop from './GoMenuDrop';
import GoSingleQueryCtl from './goSingleQueryCtl';

export default {
    //初始化下下拉组件
    initGoMenuDrop (options) {
        return new GoMenuDrop(options);
    },
    //初始化js的单条件查询组件
    initGoSingleQueryCtl(queryCtl, elObj){
        return new GoSingleQueryCtl(queryCtl, elObj);
    }
};



// WEBPACK FOOTER //
// ./goingsrc/jsCom/comCtl/index.js